import styled from "styled-components";
import { flex } from "../../mixins";

export const Wrapper = styled.div`
  ${flex({ flexDirection: "row" })}
  border: 1px solid var(--background-secondary-color);
  border-radius: 10px;
  padding: 5px;
  background-color: var(--background-secondary-color);
  transition: var(--transition);
`;

export const Button = styled.button`
  ${flex({ flexDirection: "row" })}
  gap:5px;
  border-radius: 5px;
  padding: 5px;
  background-color: ${({ isactive }) =>
    isactive === "true" ? "var(--text-color)" : "none"};
  color: ${({ isactive }) =>
    isactive === "true"
      ? "var(--background-color)"
      : "var(--text-secondary-color)"};
  transition: var(--transition);
`;
